import { Timestamp } from '@bufbuild/protobuf/wkt'
import { Timeline } from 'antd'

import { DocumentError } from '@/gen/artifacts/v1/model_pb'

import { DocumentStatus } from '@/const/artifact-status.types'
import { documentErrorLabel } from '@/const/label'

import { useTrackCallback } from '@/lib/analytics/events'

import { Tooltip } from '@/components/lemmala-design-system/tooltip/tooltip'
import { BaseDocumentStatusBadge } from '@/components/shared/document-status-badge/base-document-status-badge'
import { DocumentErrorMessage } from '@/components/shared/document-status-badge/document-error-message'
import { getTimelineItems } from '@/components/shared/document-status-badge/utils'

interface DocumentStatusBadgeProps {
  status: DocumentStatus
  error?: DocumentError
  lastUpdated?: Timestamp
}

export const DocumentStatusBadge = ({ status, error, lastUpdated }: DocumentStatusBadgeProps) => {
  const trackArtifactErrorTooltipOpen = useTrackCallback('artifact.error-tooltip.open')
  const isTooltipDisabled = status === DocumentStatus.COMPLETE && !error

  return (
    <div className='flex items-center justify-between gap-2'>
      <Tooltip
        onOpenChange={(open) => {
          if (open) {
            trackArtifactErrorTooltipOpen({
              error: documentErrorLabel[error || DocumentError.UNSPECIFIED],
            })
          }
        }}
        tooltipDisabled={isTooltipDisabled}
        className='p-0'
        trigger={
          <BaseDocumentStatusBadge status={status} error={error} hoverable={!isTooltipDisabled} />
        }
      >
        {error !== DocumentError.UNSPECIFIED && error && (
          <div className='flex flex-col gap-3 border-b p-4'>
            <BaseDocumentStatusBadge highlighted status={status} error={error} />
            <DocumentErrorMessage error={error} />
          </div>
        )}
        <div className='p-5 pt-8'>
          <Timeline className='h-28' items={getTimelineItems(status, error, lastUpdated)} />
        </div>
      </Tooltip>
    </div>
  )
}
